import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=61386736&scoped=true"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
import style0 from "./QA.vue?vue&type=style&index=0&id=61386736&prod&lang=scss"
import style1 from "./QA.vue?vue&type=style&index=1&id=61386736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61386736",
  null
  
)

export default component.exports